// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "fernando-conrado.firebaseapp.com",
  "projectId": "fernando-conrado",
  "storageBucket": "fernando-conrado.appspot.com",
  "messagingSenderId": "372421559219",
  "appId": "1:372421559219:web:00d5b49345664b63db81c6",
  "measurementId": "G-NHWN3P09K9",
  "apiKey": "AIzaSyAbKQ_9hw4QGY3SUJbelhp8eD0wHIwY2aI"
};
